/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonEventPartyCompInfo
 */
export interface JsonEventPartyCompInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonEventPartyCompInfo
     */
    allowedActions?: Array<JsonEventPartyCompInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    compAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyCompInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    eventPartyCompId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    eventPartyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyCompInfo
     */
    status?: JsonEventPartyCompInfoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    tariffId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyCompInfo
     */
    tariffType?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyCompInfo
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    unitAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    unitCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    unitRate?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyCompInfo
     */
    unitTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyCompInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyCompInfo
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonEventPartyCompInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyCompInfoStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE',
    Paid = 'PAID'
}

export function JsonEventPartyCompInfoFromJSON(json: any): JsonEventPartyCompInfo {
    return JsonEventPartyCompInfoFromJSONTyped(json, false);
}

export function JsonEventPartyCompInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonEventPartyCompInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'compAmount': !exists(json, 'compAmount') ? undefined : json['compAmount'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'eventPartyCompId': !exists(json, 'eventPartyCompId') ? undefined : json['eventPartyCompId'],
        'eventPartyId': !exists(json, 'eventPartyId') ? undefined : json['eventPartyId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'tariffId': !exists(json, 'tariffId') ? undefined : json['tariffId'],
        'tariffType': !exists(json, 'tariffType') ? undefined : json['tariffType'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'unitAmount': !exists(json, 'unitAmount') ? undefined : json['unitAmount'],
        'unitCnt': !exists(json, 'unitCnt') ? undefined : json['unitCnt'],
        'unitRate': !exists(json, 'unitRate') ? undefined : json['unitRate'],
        'unitTitle': !exists(json, 'unitTitle') ? undefined : json['unitTitle'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonEventPartyCompInfoToJSON(value?: JsonEventPartyCompInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'compAmount': value.compAmount,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'eventPartyCompId': value.eventPartyCompId,
        'eventPartyId': value.eventPartyId,
        'status': value.status,
        'tariffId': value.tariffId,
        'tariffType': value.tariffType,
        'title': value.title,
        'unitAmount': value.unitAmount,
        'unitCnt': value.unitCnt,
        'unitRate': value.unitRate,
        'unitTitle': value.unitTitle,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

